import Component from 'vue-class-component';
import BasketElementAbstract from '../BasketAbstract/BasketElementAbstract';

@Component({
})
export default class BasketElementRow extends BasketElementAbstract {

}